/**
 * Toast Utilities - Erweiterte Toast-Funktionen mit Schließen-Button
 * Behält das Original-Design und die Animationen bei
 */
import toast from 'react-hot-toast';

/**
 * Erstellt einen Toast mit Schließen-Button
 * @param {string} message - Die Nachricht
 * @param {object} options - Toast-Optionen (type: 'success' | 'error' | 'info', duration, icon)
 */
export const dismissableToast = (message, options = {}) => {
  const { type = 'success', duration = 4000, icon } = options;

  const toastContent = (t) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
      <span style={{ flex: 1 }}>{message}</span>
      <button
        onClick={() => toast.dismiss(t.id)}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '2px 6px',
          marginLeft: '8px',
          opacity: 0.6,
          fontSize: '14px',
          lineHeight: 1,
          borderRadius: '4px',
          transition: 'opacity 0.2s, background 0.2s',
        }}
        onMouseEnter={(e) => {
          e.target.style.opacity = '1';
          e.target.style.background = 'rgba(0,0,0,0.1)';
        }}
        onMouseLeave={(e) => {
          e.target.style.opacity = '0.6';
          e.target.style.background = 'none';
        }}
        title="Schließen"
      >
        ✕
      </button>
    </div>
  );

  const toastOptions = {
    duration,
    ...(icon && { icon }),
  };

  switch (type) {
    case 'error':
      return toast.error(toastContent, toastOptions);
    case 'info':
      return toast(toastContent, toastOptions);
    case 'success':
    default:
      return toast.success(toastContent, toastOptions);
  }
};

/**
 * Success Toast mit Schließen-Button
 */
export const successToast = (message, options = {}) =>
  dismissableToast(message, { ...options, type: 'success' });

/**
 * Error Toast mit Schließen-Button
 */
export const errorToast = (message, options = {}) =>
  dismissableToast(message, { ...options, type: 'error' });

/**
 * Info Toast mit Schließen-Button
 */
export const infoToast = (message, options = {}) =>
  dismissableToast(message, { ...options, type: 'info' });

export default {
  success: successToast,
  error: errorToast,
  info: infoToast,
  dismissable: dismissableToast,
};
